export enum NetworkStatus {
	Online = '[NetworkStatus] Online',
	Offline = '[NetworkStatus] Offline',
	Available = 'available',    // the network state send from shell
	Unavailable = 'unavailable'  // the network state send from shell
}
